import { render, staticRenderFns } from "./AbookTab.vue?vue&type=template&id=b29efd5e"
import script from "./AbookTab.vue?vue&type=script&lang=js"
export * from "./AbookTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports